import { render, staticRenderFns } from "./UpdateSchool.vue?vue&type=template&id=8d6d87c4&scoped=true"
import script from "./UpdateSchool.vue?vue&type=script&lang=js"
export * from "./UpdateSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6d87c4",
  null
  
)

export default component.exports